import { z } from 'zod'
import { ArchivableSchema } from '../archive'
import { idSchemaV2, isId } from '../ids'
import { ProgramTaskCriteriaSchema } from './criteria'
import { ProgramTaskScheduleSchema } from './schedule'
import { TaskTypeSchema } from './task'

export const ProgramTaskIdSchema = idSchemaV2('PT')
export type ProgramTaskId = z.infer<typeof ProgramTaskIdSchema>
export const isProgramTaskId = isId(ProgramTaskIdSchema)

export const ProgramTaskExpirationSchema = z.union([
  z
    .number()
    .optional()
    .describe('minutes after the due that the task can still be completed, 0 for expires at due date'),
  z.literal('programEndDate').describe('expires at the end of the program'),
])
export type ProgramTaskExpiration = z.infer<typeof ProgramTaskExpirationSchema>

export const UnsavedProgramTaskSchema = z.object({
  programTaskId: ProgramTaskIdSchema.optional(),
  type: TaskTypeSchema,
  subject: z.string(),
  body: z.string(),
  schedule: ProgramTaskScheduleSchema,
  criteria: z.array(ProgramTaskCriteriaSchema),
  openSince: z.number().optional().describe('minutes from midnight that the task can be started, default is midnight'),
  duration: z.number().optional().describe('duration of task in minutes, default is end of day'),
  priority: z.number().describe('priority of the task'),
  /** @deprecated - use nextTaskIds */
  nextTaskId: ProgramTaskIdSchema.optional().meta({ deprecated: true }),
  nextTaskIds: ProgramTaskIdSchema.array().optional(),
  expiration: ProgramTaskExpirationSchema.optional(),
  required: z.boolean().optional().describe('is the task required'),
})
export type UnsavedProgramTask = z.infer<typeof UnsavedProgramTaskSchema>

export const ProgramTaskSchema = z.object({
  ...ArchivableSchema.shape,
  ...UnsavedProgramTaskSchema.required({ programTaskId: true }).shape,
})
export type ProgramTaskData = z.infer<typeof ProgramTaskSchema>
